import { isProd } from '@web-app/utils/env.utils';

export const prefix = '[GrowthBook]';

export const apiHost = 'https://cdn.growthbook.io';
export const clientKey = isProd
  ? 'sdk-EBKFxVAQFXxJpUgc' // todo: make this env vars
  : 'sdk-Q3eeHJeiYuLNfKTS';

export const GROWTHBOOK_FEATURE_FLAGS = {
  ABBOTT_CGM_ENABLED: 'abbott-cgm-enabled',
  ADDITIONAL_BENEFITS_CHECK: 'additional-benefits-check',
  ADD_TO_CALENDAR_DAY_WEEK_MONTH: 'add-to-calendar-day-week-month',
  AVAILABILITY_CHECK_REMINDER_ENABLED: 'availability-check-reminder-enabled',
  AVAILABILITY_FULL_VISIBILITY: 'availability-full-visibility',
  AVAILABLE_ICD_CODES: 'available-icd-codes',
  CHARTING_NOTES_ADDENDUM_ENABLED: 'charting-notes-addendum-enabled',
  CONFIRM_CANCELLATION: 'confirm-cancellation',
  END_CALL_GRACE_PERIOD: 'end-call-grace-period-enabled',
  GROUP_PRACTICE_INVOICE: 'group-practice-provider-portal-invoice',
  IN_SESSION_CLINICAL_GOALS: 'in-session-clinical-goals',
  IN_SESSION_SCHEDULING: 'in-session-scheduling',
  IS_PRESCRIBER_FLOW: 'is-prescriber-flow',
  LINGO_ENABLED: 'lingo-enabled',
  MEAL_PLAN_IN_SESSION: 'provider-portal-meal-gen-in-session',
  MFA_PHONE_PROMPT: 'mfa-phone-prompt',
  REAL_TIME_TRANSCRIPT: 'real-time-transcript',
  READ_NOTES_FROM_DB_ENABLED: 'read-notes-from-db-enabled',
  RECURRING_APPOINTMENTS_ENABLED: 'recurring-appointments-provider-portal',
  SHOW_LAB_DOCUMENTS_TAB: 'show-lab-documents-tab',
  SHOW_PROVIDER_SCORING_FRIENDLY_FEEDBACK:
    'show-provider-scoring-friendly-feedback',
  SELECTED_FEE_DECISIONS: 'selected-fee-decisions',
  SETTINGS_PAGE_ACCESS: 'settings-page-access',
  SHOULD_SIGN_NOTE_ON_SUBMIT: 'should-sign-note-on-submit',
  SHOULD_LOCK_NOTE_ON_SUBMIT: 'should-lock-note-on-submit',
  SUPERVISION_TASKS: 'supervision-tasks',
  SUPPORT_CONCIERGE: 'support-concierge',
  SUPPORT_CONCIERGE_ALERTS: 'support-concierge-alerts',
  MANAGE_PRACTICE_DASHBOARD: 'manage-practice-dashboard',
  PERFORMANCE_DASHBOARD: 'performance-dashboard',
  PROVIDER_CALENDAR: 'provider-calendar',
  PROVIDER_PORTAL_MEAL_GEN: 'provider-portal-meal-gen',
  MEAL_PLAN_SHOPPING_LIST_MACROS: 'meal-plan-shopping-list-macros',
  PATIENT_CARE_PLAN_FOLLOWUP: 'patient-care-plan-followup',
  ICD_SEARCH_VIA_PLATFORM: 'icd-search-via-platform',
  W9_PAGE_ENABLED: 'w9-page-enabled',
  WEIGHT_HEIGHT_VIA_PLATFORM: 'weight-height-via-platform',
  CHARTING_NOTES_VIA_PLATFORM: 'charting-notes-via-platform',
  CHARTING_NOTE_WRITES_VIA_PLATFORM: 'charting-note-writes-via-platform',
  INSURANCE_DETAILS_VIA_PLATFORM: 'insurance-details-via-platform',
  PAYER_READS_VIA_PLATFORM: 'payer-reads-via-platform',
  FOLLOW_UP_VISITS_VIA_PLATFORM: 'follow-up-visits-via-platform',
  USER_GROUP_VIA_PLATFORM: 'user-group-via-platform',
  DECOUPLED_TRANSCRIPTION: 'decoupled-transcription',
  CHAT_ENABLED: 'chat-enabled',
  PRESCRIPTION_REVIEW_DOCUMENT_REQUESTS:
    'prescription-review-document-requests',
  PRESCRIPTION_REVIEW_ZUS_PROFILE: 'prescription-review-zus-profile',
  PRESCRIPTION_REVIEW_PHOTON_PRESCRIBE: 'prescription-review-photon-prescribe',
  PRESCRIPTION_TASKS: 'prescription-tasks',
  SUB_ORGS_INVOICE_REVIEW_EXCLUDE: 'sub-orgs-invoice-review-exclude',
  NON_APPOINTMENT_HOURS_TRACKING: 'non-appointment-hours-tracking',
  SHOW_MEAL_SUMMARY_ON_PREP: 'show-meal-summary-on-prep',
  IN_SESSION_TEMPLATES_MANAGEMENT: 'in-session-templates-management',
  IN_SESSION_TEMPLATES_ADMIN: 'in-session-templates-admin',
  LAB_RESULTS: 'lab-results',
  PROVIDER_ATTESTATION_DOCUMENTS: 'provider-attestation-documents',
  WALMART_SHOPPING_INSIGHTS: 'walmart-shopping-insights',
  ZOC_DOC_POPUP_ENABLED: 'zoc-doc-popup-enabled',
} as const;
